import { connect } from 'react-redux';

import { sortUsers } from '../../helpers/ArrayUtils';
import * as AppConstants from '../../constants/AppConstants';
import BrowsePanel from './BrowsePanel';
import { removeInactiveUsers } from '../../helpers/UserUtils';

const mapStateToProps = state => {
  const users = removeInactiveUsers(state.users);
  const { chats, identity, publicChannels } = state;

  const getMainUserId = chat => {
    if (chat.users && chat.users.length === 2) {
      return chat.users
        .filter(id => id !== identity.id)
        .map(id => id)
    } else if (chat.users && chat.users.length === 1) {
      return identity.id
    } else {
      return 0;
    }
  };

  // create an array with a list of userIDs for anyone you already have a chat with
  const twoUserChats = Object.keys(chats)
    .filter(id => chats[id].type === AppConstants.DIRECT_MESSAGE && chats[id].users.length <= 2)
    .map(id => chats[id].users
      .filter(id => id !== identity.id) // the users array will have two users, so remove your own user to find who the DM is with
      .toString()
    );

  // if you already have a chat with someone, we do not want them added to updatedUsers as they'll be a part of updatedChats instead
  const updatedUsers = Object.keys(users)
    .filter(id => {
      return !twoUserChats.includes(id) && parseInt(id, 10) !== identity.id
    })
    .map(id => ({
      ...users[id],
      name: `${users[id].firstName} ${users[id].lastName}`.trim(),
      type: AppConstants.USER,
      users: []
    }));

  const updatedChats = Object.keys(chats)
    .map(id => ({
        ...chats[id],
        mainUserId: getMainUserId(chats[id])
      })
    );

  const updatedPublicChannels = Object.keys(publicChannels)
    .filter(id => !chats[id])
    .map(id => publicChannels[id]);

  // adding the true prop will sort things by name instead of [firstName lastName] since we will always have a name value here
  const allResults = sortUsers([
    ...updatedUsers,
    ...updatedChats,
    ...updatedPublicChannels
  ], true);

  return {
    allResults,
    identity
  }
};

export default connect(mapStateToProps)(BrowsePanel);
